import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule, Routes } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';

import 'hammerjs';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { ToastrModule } from 'ngx-toastr'; // For auth after login toast

import { CoreModule } from '@core/core.module';
import { CoreCommonModule } from '@core/common.module';
import { CoreSidebarModule, CoreThemeCustomizerModule } from '@core/components';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { coreConfig } from 'app/app-config';

import { AppComponent } from 'app/app.component';
import { LayoutModule } from 'app/componentes/layout/layout.module';
import { SampleModule } from 'app/componentes/main/sample/sample.module';
import { AuthGuard } from './componentes/auth/helpers';
import { NgSelectModule } from '@ng-select/ng-select';
import { BlockUIModule } from 'ng-block-ui';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FileUploadModule } from 'ng2-file-upload';
import { ContentHeaderModule } from 'app/componentes/layout/components/content-header/content-header.module';
import { PromocionesComponent } from 'app/promociones/promociones.component';

const appRoutes: Routes = [
  {
    path: '',
    redirectTo: '/facturacion/facturar',
    pathMatch: 'full'
  },
  {
    path: 'facturacion',
    loadChildren: () => import('./facturacion/facturacion.module').then(m => m.FacturacionModule),    
  },
  {
    path: 'pages',
    loadChildren: () => import('./componentes/main/pages/miscellaneous/miscellaneous.module').then(m => m.MiscellaneousModule)
  },
  {
    path: '**',
    redirectTo: '/pages/error' //Error 404 - Page not found
  }
];

@NgModule({
  declarations: [AppComponent, PromocionesComponent],
  imports: [
    BlockUIModule.forRoot(),
    SweetAlert2Module.forRoot(),
    FileUploadModule,
    NgxDatatableModule,
    NgSelectModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    RouterModule.forRoot(appRoutes, {
      scrollPositionRestoration: 'enabled', // Add options right here
      relativeLinkResolution: 'legacy'
    }),
    TranslateModule.forRoot(),
    //NgBootstrap
    NgbModule,
    ToastrModule.forRoot(),

    // Core modules
    CoreModule.forRoot(coreConfig),
    CoreCommonModule,
    CoreSidebarModule,
    CoreThemeCustomizerModule,

    // App modules
    LayoutModule,
    SampleModule,
    FlexLayoutModule,
    ContentHeaderModule
  ],

  bootstrap: [AppComponent]
})
export class AppModule {}